import { render } from "./MyTitle.vue?vue&type=template&id=0f1a3f04&scoped=true"
import script from "./MyTitle.vue?vue&type=script&lang=js"
export * from "./MyTitle.vue?vue&type=script&lang=js"

import "./MyTitle.vue?vue&type=style&index=0&id=0f1a3f04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f1a3f04"]])

export default __exports__